<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/cooperativePriceList' }">合作价格</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails(list.approval_status)">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details details_link">
                        <el-form-item label="code：">
                            <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作方：">
                            <div class="read_only read_only_link">
                                <span @click="partnerClick(list.partner_rid)">{{ list.partner_name }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="产品：">
                            <div class="read_only read_only_link">
                                <span @click="productClick(list.product_rid)">{{ list.product_name }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="产品代码：">
                            <div class="read_only read_only_link">
                                <span @click="productClick(list.product_rid)">{{ list.product_code }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="省份：">
                            <el-input v-model="list.province_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="城市：">
                            <el-input v-model="list.city_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="需方：">
                            <el-input v-model="list.demander_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="特征码：">
                            <el-input v-model="list.feature_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="开始日期：">
                            <el-input v-model="list.start_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="结束日期：">
                            <el-input v-model="list.end_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="时效性：">
                            <el-input v-model="list.timeliness_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：">
                            <el-input
                                v-model="list.approval_status_label"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发票单价：">
                            <el-input v-model="list.unit_invoice_price" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="单位限额：">
                            <el-input
                                v-model="list.unit_marginal_expense_quota"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：">
                            <el-input
                                v-model="list.marginal_expense_provision_rate"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="VATR：">
                            <el-input v-model="list.value_added_tax_rate" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="单位底价：">
                            <el-input v-model="list.unit_base_price" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作规划code：">
                            <el-input v-model="list.partner_scheme_rid" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="提交人职位：">
                            <el-input
                                v-model="list.submission_hierarchy_name"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by">
                            <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by">
                            <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="流程行列表" name="2">
                    <!-- <div class="main_list">
                        <div class="toolbar flex">
                            <el-popover placement="left" trigger="click" class="top_btn" width="200px">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                                    >全选</el-checkbox
                                >
                                <el-checkbox-group
                                    v-model="colOptions"
                                    style="display: flex; flex-direction: column"
                                    @change="handleCheckedCitiesChange"
                                >
                                    <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
                                </el-checkbox-group>
                                <el-button slot="reference" size="mini" icon="el-icon-setting">设置</el-button>
                            </el-popover>
                        </div>
                        <el-table :data="dataList" border style="width: 100%" ref="tableDataRef" element-loading-text="数据拼命加载中">
                            <el-table-column
                                v-if="colData[0].istrue"
                                prop="rel_name"
                                label="对象名称"
                                align="left"
                                show-overflow-tooltip
                                width="120px"
                            >
                            </el-table-column>
                            <el-table-column v-if="colData[1].istrue" prop="name" label="流程行名称" align="left" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                v-if="colData[2].istrue"
                                prop="status_label"
                                label="状态"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column v-if="colData[3].istrue" prop="type_label" label=" 类型" align="left" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                v-if="colData[4].istrue"
                                prop="operator_hierarchy_names"
                                label="可审批职位"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[5].istrue"
                                prop="operator_name"
                                label="审批人"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[6].istrue"
                                prop="operator_hierarchy_name"
                                label="审批人职位"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[7].istrue"
                                prop="operation_label"
                                label="执行意见"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[8].istrue"
                                prop="comment"
                                label="意见说明"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[9].istrue"
                                prop="sequence"
                                label="序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[10].istrue"
                                prop="next_sequence"
                                label="下一步序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[11].istrue"
                                prop="operator_number"
                                label="执行人数"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column label="操作" width="180">
                                <template slot-scope="scope" style="height: 100%">
                                    <div v-show="scope.row.wait_me_approve == 1">
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(3, scope)"
                                        >
                                            <span>通过</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(4, scope)"
                                        >
                                            <span>拒绝</span>
                                        </button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-dialog
                            v-dialogDrag
                            :close-on-click-modal="false"
                            title="审核意见"
                            :visible.sync="dialogVisibleLine"
                            width="30%"
                        >
                            <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
                            <span slot="footer" class="dialog-footer">
                                <el-button
                                    @click="
                                        dialogVisibleLine = false;
                                        comment = '';
                                    "
                                    >取 消</el-button
                                >
                                <el-button type="primary" @click="subData">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div> -->
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    name: 'cooperativePriceDetail',
    data() {
        return {
            list: {},
            activeNames: ['1', '2'],
            rid: '',
            echartShow: false,
            headerTitle: '合作价格详情',
            comment: '',
            dialogVisibleLine: false,
            dataList: [],
            dataType: '',
            //控制列
            colData: [
                { title: '对象名称', istrue: true },
                { title: '流程行名称', istrue: true },
                { title: '状态', istrue: true },
                { title: '类型', istrue: true },
                { title: '可审批职位', istrue: true },
                { title: '审批人', istrue: true },
                { title: '审批人职位', istrue: true },
                { title: '执行意见', istrue: true },
                { title: '意见说明', istrue: true },
                { title: '序号', istrue: true },
                { title: '下一步序号', istrue: true },
                { title: '执行人数', istrue: true }
            ],
            colOptions: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ], //默认全选
            // 筛选列
            colSelect: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ],
            checkAll: true,
            isIndeterminate: false,
            selected: [],
            rids: []
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
            this.getLineList(); //获取流程行列表
        },
        //控制列显示
        colOptions(valArr) {
            var arr = this.colSelect.filter((i) => valArr.indexOf(i) < 0); // 未选中
            this.colData.filter((i) => {
                if (arr.indexOf(i.title) != -1) {
                    i.istrue = false;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                } else {
                    i.istrue = true;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                }
            });
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.getLineList(); //获取流程行列表
    },
    methods: {
        //全选设置列表 列显示
        handleCheckAllChange(val) {
            this.isIndeterminate = false;
            if (val) {
                this.colOptions = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelect = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
            } else {
                this.colOptions = [];
            }
        },
        //单选设置列表 列显示
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.colData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.colData.length;
        },
        //type == 3审批通过 type ==4 拒绝
        okPassLine(type, scope) {
            this.dataType = type;
            this.dialogVisibleLine = true;
            this.rids.push(scope.row.rel_rid);
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                let postData = {
                    rids: this.rids,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .partnerPriceBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '审批通过!',
                                type: 'success'
                            });
                            this.getDetails(); //获取详情
                            this.getLineList(); //获取流程行列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            } else if (this.dataType == 4) {
                //此处为拒绝
                let postData = {
                    rids: this.rids,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .partnerPriceBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '已拒绝!',
                                type: 'waring'
                            });
                            this.getDetails(); //获取详情
                            this.getLineList(); //获取流程行列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        //获取流程行列表
        getLineList() {
            let params = {
                for_detail: 1,
                rel_type: 'partner_price',
                rel_rid: this.rid
            };
            this.$api
                .procedureLineDetailsList(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dataList = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //删除
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .partnerPriceDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/cooperativePriceList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //合作方详情跳转
        partnerClick(rid) {
            this.$router.push({
                path: 'partnerDetails',
                query: {
                    id: rid
                }
            });
        },
        //产品详情跳转
        productClick(rid) {
            this.$router.push({
                path: 'productListDetails',
                query: {
                    id: rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'cooperativePriceEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //前往编辑页面
        editDetails(status) {
            if (status == 3) {
                this.$message({
                    message: '审批状态为已批准的不能修改！',
                    type: 'warning'
                });
            } else {
                this.$router.push({
                    path: '/cooperativePriceEdit',
                    query: {
                        type: 1,
                        id: this.rid
                    }
                });
            }
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'cooperativePriceEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/cooperativePriceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .partnerPriceDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>